import $ from 'jquery'
import 'select2/dist/js/select2.full.min'
import 'select2/dist/js/i18n/ru'

class Module {
  constructor ($module) {
    this.$module = $module

    const $country = $module.find('.form-group_country select')
    const $city = $module.find('.form-group_city select')
    let countryVal = null;

    [$country, $city].forEach(function ($el) {
      $el.select2({
        ajax: {
          data: function (params) {
            const request = {
              search: params.term,
              page: params.page || 1
            }

            if ($(this).is($city)) {
              request.country = $country.val()
            }

            return request
          },
          processResults: function (data) {
            return {
              results: data.items.map(function (i) {
                return {
                  id: i.id,
                  text: i.name
                }
              }),
              pagination: {
                more: data.pagination.page < data.pagination.total_pages
              }
            }
          }
        }
      })

      $country.on('change', function () {
        if ($(this).val() !== countryVal) {
          countryVal = $(this).val()
          $city.val('').trigger('change')
        }

        if (!$country.val()) {
          $city.attr('disabled', 'disabled')
        } else {
          $city.removeAttr('disabled')
        }
      }).trigger('change')
    })
  }
}

$(function () {
  $('form[name="facebook_account"]').each(function () {
    new Module($(this))
  })
})
